import React, {useState} from "react";
import {CreateWatchdog} from "../components/create-watchdog";
import {ListBlock} from "./ListBlock";
import {SideItemRow} from "./SideItemRow";

export const WatchdogsBlock = ({project, onUpdateProject, getUserProjects}) => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [search, setSearch] = useState("");

    const onUpdateCollections = async (data) => {
        await onUpdateProject({...data});
        await getUserProjects();
    };

    const onRemove = async (id) => {
        const newProject = {...project};
        newProject.watchdogs = newProject?.watchdogs?.filter((item) => item.id !== id) || [];
        await onUpdateProject(newProject);
        await getUserProjects();
    };

    const items = project?.watchdogs?.filter(
        (item) => item?.name?.toLowerCase()?.includes(search?.toLowerCase()),
    ) || [];

    return (
        <>
            <CreateWatchdog
                open={openModal}
                project={project}
                selectedWatchdog={selectedItem}
                handleClose={() => {
                    setOpenModal(false);
                    setSelectedItem(null);
                }}
                handleSubmit={onUpdateCollections}
                onRemove={onRemove}
            />
            <ListBlock
                title="Watchdogs"
                items={items}
                search={search}
                onChangeSearch={setSearch}
                onCreate={() => setOpenModal(true)}
                mapItem={(watchdog) => (
                    <SideItemRow
                        key={watchdog?.id}
                        label={watchdog?.name}
                        tooltip={watchdog?.name}
                        onClick={() => {
                            setSelectedItem(watchdog);
                            setOpenModal(true);
                        }}
                    />
                )}
            />
        </>
    );
};
